import { render, staticRenderFns } from "./signal_open_list.vue?vue&type=template&id=bbd2c306"
import script from "./signal_open_list.vue?vue&type=script&lang=js"
export * from "./signal_open_list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports